import t, { Component as _ } from "react";
import e from "prop-types";
import d from "react-onclickoutside";
import { d as u } from "./deprecate-Dt6BL0Y6.es.js";
import { I as c } from "./Icon-ByeAHRM4.es.js";
import './SplitButton.css';const m = "SplitButton-module__container___5ueFw", w = "SplitButton-module__main_option___hHdwZ", x = "SplitButton-module__only_option___cS18c", h = "SplitButton-module__dropdown_trigger___2YUox", g = "SplitButton-module__option___9xAZ0", f = "SplitButton-module__dropdown_trigger_positioner___wkHO-", y = "SplitButton-module__dropdown_icon___8-Vfx", S = "SplitButton-module__text___wxuXc", E = "SplitButton-module__text_wrap_handler___wwbF5", B = "SplitButton-module__icon___s-AKT", O = "SplitButton-module__dropdown_container___3YJ6n", o = {
  container: m,
  main_option: w,
  only_option: x,
  dropdown_trigger: h,
  option: g,
  dropdown_trigger_positioner: f,
  dropdown_icon: y,
  text: S,
  text_wrap_handler: E,
  icon: B,
  dropdown_container: O
}, s = (i) => /* @__PURE__ */ t.createElement("button", { className: o.option, onClick: i.action, type: "button" }, /* @__PURE__ */ t.createElement("div", { className: o.text }, /* @__PURE__ */ t.createElement("div", { className: o.text_wrap_handler }, /* @__PURE__ */ t.createElement("div", { className: o.icon }, i.icon ? t.cloneElement(i.icon, {
  color: "currentColor",
  size: 12
}) : null), i.text)));
s.propTypes = {
  text: e.string.isRequired,
  action: e.func.isRequired,
  icon: e.shape({ type: e.oneOf([c, void 0]) })
};
s.defaultProps = {
  icon: void 0
};
function a(i) {
  return /* @__PURE__ */ t.createElement("div", { className: o.dropdown_container }, i.options.map((n) => /* @__PURE__ */ t.createElement(
    s,
    {
      key: n.text,
      text: n.text,
      action: n.action,
      icon: n.icon
    }
  )));
}
a.propTypes = {
  options: e.arrayOf(
    e.shape({
      text: e.string.isRequired,
      action: e.func.isRequired,
      icon: e.shape({ type: e.oneOf([c, void 0]) })
    })
  )
};
a.defaultProps = {
  options: []
};
class p extends _ {
  constructor() {
    super(), this.state = {
      open: !1
    }, this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  handleClickOutside() {
    this.setState({ open: !1 });
  }
  render() {
    const n = this.props.options.map((r) => ({
      text: r.text,
      action: () => {
        this.setState({ open: !1 }), r.action();
      },
      icon: r.icon
    })), l = n.length < 2;
    return /* @__PURE__ */ t.createElement("div", { className: o.container }, /* @__PURE__ */ t.createElement(
      "div",
      {
        className: l ? o.only_option : o.main_option
      },
      /* @__PURE__ */ t.createElement(
        s,
        {
          text: n[0].text,
          action: n[0].action,
          icon: n[0].icon
        }
      )
    ), !l && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "button",
      {
        className: o.dropdown_trigger,
        onClick: () => {
          this.setState((r) => ({
            open: !r.open
          }));
        },
        type: "button"
      },
      /* @__PURE__ */ t.createElement("div", { className: o.dropdown_trigger_positioner }, /* @__PURE__ */ t.createElement(
        c,
        {
          className: o.dropdown_icon,
          size: 12,
          color: "currentColor",
          name: "arrow_down"
        }
      ))
    ), this.state.open ? /* @__PURE__ */ t.createElement(a, { options: n.slice(1) }) : null));
  }
}
p.propTypes = {
  /** The first option is the primary action, the others get put into the dropdown.
   * If only one option, there won't be a dropdown. See below for more info.
   */
  options: e.arrayOf(
    e.shape({
      text: e.string.isRequired,
      action: e.func.isRequired,
      icon: e.shape({ type: e.oneOf([c, void 0]) })
    })
  )
};
p.defaultProps = {
  options: []
};
const v = d(p), q = u(
  "SplitButton is deprecated. Use another component instead."
)((i) => /* @__PURE__ */ t.createElement(v, { ...i, eventTypes: ["click"] }));
export {
  q as D
};
